import styled from "styled-components";
import {device} from "../../../utils/device";

const ContentHome = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  min-height: 500px;
`;

export default ContentHome;
